import { parseNovelReviewDetail, parseNovelReviewList, parseNovelReviewResponse } from '@drama/contracts/novel'
import { novelAdminHttp } from './http.js'

export async function listNovelReviews(status) {
  return parseNovelReviewList(await novelAdminHttp().get('/reviews', {
    query: status ? { status } : {}, routeId: 'novel.admin.reviews.list',
  }))
}
export async function getNovelReview(review_id) {
  return parseNovelReviewDetail(await novelAdminHttp().get(`/reviews/${encodeURIComponent(review_id)}`, {
    routeId: 'novel.admin.reviews.detail',
  }))
}
export async function prepareNovelReview(review_id, providers = []) {
  return parseNovelReviewResponse(await novelAdminHttp().post(`/reviews/${encodeURIComponent(review_id)}/prepare`, {
    body: { providers }, routeId: 'novel.admin.reviews.prepare',
  }))
}
export async function decideNovelReview(review_id, body) {
  return parseNovelReviewResponse(await novelAdminHttp().post(`/reviews/${encodeURIComponent(review_id)}/decision`, {
    body, routeId: 'novel.admin.reviews.decision',
  }))
}
